import { render, staticRenderFns } from "./samplepage.vue?vue&type=template&id=33a1c491"
import script from "./samplepage.vue?vue&type=script&lang=js"
export * from "./samplepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports